import React from 'react';
import { Button, Badge, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import AIAssistantPanel from './AIAssistantPanel';
import AIAssistantIcon from './AIAssistantIcon';
import AIBrainIcon from './AIBrainIcon';
import AIGeometricIcon from './AIGeometricIcon';
import { useMaestroContext } from '@/contexts/MaestroContext';
import './AIAssistantTrigger.less';

interface PageDataContext {
  statistics?: any;
  transactions?: any[];
  integrationConfig?: any;
  analyticsData?: any;
}

interface AIAssistantTriggerProps {
  context?: 'integration-builder' | 'dashboard' | 'general';
  hasNotifications?: boolean;
  iconStyle?: 'neural' | 'brain' | 'geometric';
  integrationId?: string;
  integrationName?: string;
  pageData?: PageDataContext;
}

const AIAssistantTrigger: React.FC<AIAssistantTriggerProps> = ({ 
  context = 'general',
  hasNotifications = false,
  iconStyle = 'geometric',
  integrationId,
  integrationName,
  pageData
}) => {
  const { isPanelOpen, togglePanel, closePanel, pageData: contextPageData } = useMaestroContext();
  const resolvedPageData = pageData || contextPageData || undefined;

  const renderIcon = () => {
    if (isPanelOpen) {
      return <CloseOutlined />;
    }
    
    const iconProps = {
      size: 28,
      color: 'white',
      animate: !isPanelOpen
    };

    switch (iconStyle) {
      case 'neural':
        return <AIAssistantIcon {...iconProps} />;
      case 'brain':
        return <AIBrainIcon {...iconProps} />;
      case 'geometric':
        return <AIGeometricIcon {...iconProps} />;
      default:
        return <AIGeometricIcon {...iconProps} />;
    }
  };

  return (
    <>
      {!isPanelOpen && (
        <div className="ai-assistant-trigger">
          <Tooltip 
            title={
              <span className="ai-assistant-tooltip">
                Ask Maestro
              </span>
            } 
            placement="left"
          >
            <Badge dot={hasNotifications} offset={[-8, 8]}>
              <Button
                type="primary"
                shape="circle"
                size="large"
                icon={renderIcon()}
                onClick={togglePanel}
                className="ai-trigger-button"
                aria-label="Ask Maestro"
              />
            </Badge>
          </Tooltip>
        </div>
      )}
      
      <AIAssistantPanel 
        visible={isPanelOpen}
        onClose={closePanel}
        context={context}
        integrationId={integrationId}
        integrationName={integrationName}
        pageData={resolvedPageData}
      />
    </>
  );
};

export default AIAssistantTrigger;
